import React, { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import emailjs from "@emailjs/browser";
import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
} from "@mui/material";
import ConfirmationCard from "../../components/ConfirmationCard/ConfirmationCard";
import ServicesData from "../Services/servicesData";

const ContactFrom = () => {
  const [modal, setModal] = useState({ show: false, success: false });
  const formRef = useRef();
  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    compony: "",
    message: "",
    checkbox: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [, forceUpdate] = useState();
  const [validator, setValidator] = useState(
    new SimpleReactValidator({
      className: "text-danger small mt-1",
      messages: {
        required: "This field is required.",
        email: "Invalid email.",
        phone: "Invalid phone.",
      },
    })
  );

  const changeHandler = (e) => {
    const { name, value } = e.target;

    // Strict input filtering
    let filteredValue = value;
    if (name === "name") {
      filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (name === "phone") {
      filteredValue = value.replace(/[^0-9]/g, "").slice(0, 10);
    }

    setForms((prev) => ({ ...prev, [name]: filteredValue }));
    validator.showMessageFor(name);
    forceUpdate(1);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (validator.allValid() && forms.checkbox) {
      setLoading(true);
      try {
        await emailjs.send(
          "service_ja6a8nv",
          "template_ve21gio",
          { ...forms },
          "rIymR7iK-BDnckH2H"
        );

        setForms({
          name: "",
          email: "",
          subject: "",
          phone: "",
          compony: "",
          message: "",
          checkbox: "",
        });
        setLoading(false);
        setSubmitted(false);
        setModal({ show: true, success: true });
      } catch (error) {
        setLoading(false);
        setModal({ show: true, success: false });
      }
    } else {
      validator.showMessages();
      forceUpdate(1);
    }
  };

  return (
    <>
      <form onSubmit={submitHandler} ref={formRef}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Full Name"
              name="name"
              value={forms.name}
              onChange={changeHandler}
              error={submitted && !validator.fieldValid("name")}
              helperText={
                submitted &&
                validator.message("name", forms.name, "required|alpha_space")
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email Address"
              name="email"
              value={forms.email}
              onChange={changeHandler}
              error={submitted && !validator.fieldValid("email")}
              helperText={
                submitted &&
                validator.message("email", forms.email, "required|email")
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Phone Number"
              name="phone"
              value={forms.phone}
              onChange={changeHandler}
              error={submitted && !validator.fieldValid("phone")}
              helperText={
                submitted &&
                validator.message(
                  "phone",
                  forms.phone,
                  "required|numeric|min:10|max:10"
                )
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Company Name"
              name="compony"
              value={forms.compony}
              onChange={changeHandler}
              error={submitted && !validator.fieldValid("compony")}
              helperText={
                submitted &&
                validator.message("compony", forms.compony, "required")
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Interested Service"
              name="subject"
              value={forms.subject}
              onChange={changeHandler}
              error={submitted && !validator.fieldValid("subject")}
              helperText={
                submitted &&
                validator.message("subject", forms.subject, "required")
              }
            >
              <MenuItem value="">Select a service</MenuItem>
              {ServicesData.map((s, i) => (
                <MenuItem key={i} value={s.sTitle}>
                  {s.sTitle}
                </MenuItem>
              ))}
              <MenuItem value="Other">Other Inquiry</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Your Message"
              name="message"
              value={forms.message}
              onChange={changeHandler}
              multiline
              rows={4}
              error={submitted && !validator.fieldValid("message")}
              helperText={
                submitted &&
                validator.message("message", forms.message, "required")
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ p: 3, bgcolor: "#f8f9fa", borderRadius: "12px" }}>
              <FormControl
                component="fieldset"
                error={submitted && !forms.checkbox}
              >
                <FormLabel
                  component="legend"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    color: "var(--primary-color) !important",
                  }}
                >
                  Where Did You Hear About Us?
                </FormLabel>
                <RadioGroup
                  row
                  name="checkbox"
                  value={forms.checkbox}
                  onChange={changeHandler}
                >
                  {["LinkedIn", "Youtube", "Emailer", "Referral", "Others"].map(
                    (source) => (
                      <FormControlLabel
                        key={source}
                        value={source}
                        control={
                          <Radio
                            sx={{
                              color: "var(--primary-color)",
                              "&.Mui-checked": {
                                color: "var(--primary-color)",
                              },
                            }}
                          />
                        }
                        label={
                          <Typography variant="body2">{source}</Typography>
                        }
                      />
                    )
                  )}
                </RadioGroup>
                {submitted && !forms.checkbox && (
                  <Typography
                    color="error"
                    variant="caption"
                    sx={{ display: "block", mt: 1 }}
                  >
                    Please select an option.
                  </Typography>
                )}
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                bgcolor: "var(--primary-color)",
                color: "#fff",
                py: 2,
                borderRadius: "12px",
                fontSize: "1.1rem",
                fontWeight: 700,
                boxShadow: "0 10px 30px rgba(26, 66, 161, 0.3)",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "var(--primary-color)",
                  filter: "brightness(1.1)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit Inquiry"
              )}
            </Button>
          </Grid>
        </Grid>
      </form>

      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            zIndex: 1050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      <ConfirmationCard modal={modal} setModal={setModal} />
    </>
  );
};

export default ContactFrom;
